import { clamp } from "lodash";
import atlasEconomy from "@/domains/estate/components/elevator/res/economy_numbers@2x.png";
import atlasStandard from "@/domains/estate/components/elevator/res/standard_numbers@2x.png";

export function ElevatorPanelNumber({
  value,
  atlasSizeX,
  atlasSizeY = 1,
  cellSize,
  atlasSrc,
  isActive,
}: {
  value: number;
  atlasSizeX: number;
  atlasSizeY?: number;
  cellSize: number;
  atlasSrc: string;
  isActive?: boolean;
}) {
  const clampedValue = clamp(value, 1, atlasSizeX * atlasSizeY);
  const xPos = (clampedValue - 1) * -cellSize;

  return (
    <div
      style={{
        width: cellSize,
        height: cellSize,
        backgroundImage: `url(${atlasSrc})`,
        backgroundSize: `${cellSize * atlasSizeX}px ${cellSize * atlasSizeY}px`,
        backgroundPosition: `${xPos}px ${isActive ? -cellSize : 0}px`,
      }}
    />
  );
}

export function ElevatorEconomyNumber({ value }: { value: number }) {
  return (
    <ElevatorPanelNumber value={value} atlasSizeX={27} cellSize={32} atlasSrc={atlasEconomy} />
  );
}

export function ElevatorStandardNumber({ value, isActive }: { value: number; isActive?: boolean }) {
  return (
    <ElevatorPanelNumber
      value={value}
      atlasSizeX={27}
      atlasSizeY={2}
      cellSize={32}
      atlasSrc={atlasStandard}
      isActive={isActive}
    />
  );
}
